import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// FastAPI store: POST /api/v1/store/cart/add
export const add_to_card = createAsyncThunk(
    'card/add_to_card',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/cart/add', { productId: info.productId, quantity: info.quantity || 1 })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: GET /api/v1/store/cart/{userId}?token=...
export const get_card_products = createAsyncThunk(
    'card/get_card_products',
    async(userId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.get(`/cart/${userId}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: DELETE /api/v1/store/cart/item/{itemId}?token=...
export const delete_card_product = createAsyncThunk(
    'card/delete_card_product',
    async(card_id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.delete(`/cart/item/${card_id}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: PUT /api/v1/store/cart/item/{itemId}/increase?token=...
export const quantity_inc = createAsyncThunk(
    'card/quantity_inc',
    async(card_id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.put(`/cart/item/${card_id}/increase?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: PUT /api/v1/store/cart/item/{itemId}/decrease?token=...
export const quantity_dec = createAsyncThunk(
    'card/quantity_dec',
    async(card_id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.put(`/cart/item/${card_id}/decrease?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: POST /api/v1/store/wishlist/add?token=...
export const add_to_wishlist = createAsyncThunk(
    'wishlist/add_to_wishlist',
    async(info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.post(`/wishlist/add?token=${token}`, info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: GET /api/v1/store/wishlist/{userId}?token=...
export const get_wishlist_products = createAsyncThunk(
    'wishlist/get_wishlist_products',
    async(userId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.get(`/wishlist/${userId}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: DELETE /api/v1/store/wishlist/item/{wishId}?token=...
export const remove_wishlist = createAsyncThunk(
    'wishlist/remove_wishlist',
    async(wishlistId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.delete(`/wishlist/item/${wishlistId}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const cardReducer = createSlice({
    name: 'card',
    initialState: {
        card_products: [],
        card_product_count: 0,
        wishlist_count: 0,
        wishlist: [],
        price: 0,
        errorMessage: '',
        successMessage: '',
        shipping_fee: 0,
        outofstock_products: [],
        buy_product_item: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        reset_count: (state) => {
            state.card_product_count = 0
            state.wishlist_count = 0
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(add_to_card.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || 'No se pudo agregar al carrito'
        })
        .addCase(add_to_card.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Producto agregado'
            state.card_product_count = state.card_product_count + 1
        })

        .addCase(get_card_products.fulfilled, (state, { payload }) => {
            // El backend devuelve una lista plana; las páginas (carrito, envío)
            // heredaron del MERN la forma agrupada por tienda con productInfo.
            // Se agrupa aquí, una sola vez, para no reescribir las páginas.
            const aInfo = (p) => ({
                _id: p.id, quantity: p.quantity,
                productInfo: { ...p, _id: p.variantId, id: p.variantId, images: [p.image], discount: p.discount || 0 },
            })
            const planos = payload?.card_products || []
            state.card_products       = planos.length ? [{ shopName: 'Señor Bigotes', sellerId: 1, products: planos.map(aInfo) }] : []
            state.price               = payload?.price              || 0
            state.card_product_count  = payload?.card_product_count || 0
            state.shipping_fee        = payload?.shipping_fee       || 0
            const fuera = payload?.outOfStockProduct || []
            state.outofstock_products = fuera.map(p => ({ _id: p.id, quantity: p.quantity, products: [{ ...p, _id: p.variantId, images: [p.image], discount: 0 }] }))
            state.buy_product_item    = payload?.buy_product_item   || 0
        })

        .addCase(delete_card_product.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Eliminado'
        })
        .addCase(quantity_inc.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Cantidad actualizada'
        })
        .addCase(quantity_dec.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Cantidad actualizada'
        })

        .addCase(add_to_wishlist.rejected, (state, { payload }) => {
            state.errorMessage = payload?.error || 'Error al agregar a wishlist'
        })
        .addCase(add_to_wishlist.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Agregado a wishlist'
            state.wishlist_count = state.wishlist_count > 0 ? state.wishlist_count + 1 : 1
        })

        .addCase(get_wishlist_products.fulfilled, (state, { payload }) => {
            state.wishlist       = payload?.wishlists     || []
            state.wishlist_count = payload?.wishlistCount || 0
        })

        .addCase(remove_wishlist.fulfilled, (state, { payload }) => {
            state.successMessage = payload?.message || 'Eliminado de wishlist'
            state.wishlist       = state.wishlist.filter(p => p._id !== payload?.wishlistId)
            state.wishlist_count = Math.max(0, state.wishlist_count - 1)
        })
    }
})

export const { messageClear, reset_count } = cardReducer.actions
export default cardReducer.reducer
